import React, { useEffect, useState } from 'react';
import axios from 'axios';

// Ustawienie uzytkownika: ktory numer zamowienia pokazywac w Wiadomosciach / Issues / Zwrotach (apilo | ok).
// Jedno zapytanie na sesje strony (wspolna pamiec podreczna), zmiana w Ustawieniach -> Moje konto.
type Src = 'apilo' | 'ok';
let cache: Src | null = null;
let pending: Promise<Src> | null = null;
const listeners: Array<(v: Src) => void> = [];

export function loadOrderNumberSource(force?: boolean): Promise<Src> {
  if (cache && !force) return Promise.resolve(cache);
  if (pending && !force) return pending;
  pending = axios.get('/api/ok-crm/prefs')
    .then((r: any) => { cache = (r.data && r.data.order_number_source === 'ok') ? 'ok' : 'apilo'; listeners.forEach((f) => f(cache as Src)); return cache as Src; })
    .catch(() => { cache = 'apilo'; return 'apilo' as Src; })
    .finally(() => { pending = null; });
  return pending;
}

export function setOrderNumberSourceCache(v: Src) {
  cache = v;
  listeners.forEach((f) => f(v));
}

export function useOrderNumberSource(): Src {
  const [v, setV] = useState<Src>(cache || 'apilo');
  useEffect(() => {
    listeners.push(setV);
    loadOrderNumberSource().then(setV);
    return () => { const i = listeners.indexOf(setV); if (i >= 0) listeners.splice(i, 1); };
  }, []);
  return v;
}

const copy = (t: string) => { try { navigator.clipboard.writeText(t); } catch (e) { /* ignore */ } };

// Numer zamowienia przy pozycji zamowienia klienta (Wiadomosci / Issues): Apilo albo OPENkontakt.
export function OrderNoBadge({ o }: { o: any }) {
  const src = useOrderNumberSource();
  const ok = o && o.ok_number ? String(o.ok_number) : '';
  const ap = o && o.apilo_id ? String(o.apilo_id) : '';
  if (src === 'ok' && ok) {
    return <span title="Kliknij, aby skopiować" onClick={() => copy(ok)} style={{ cursor: 'pointer' }}>OK: <b style={{ color: '#15803d' }}>{ok}</b></span>;
  }
  if (src === 'ok' && !ok) return null;
  if (!ap) return null;
  return <span title="Kliknij, aby skopiować" onClick={() => copy(ap)} style={{ cursor: 'pointer' }}>Apilo: <b style={{ color: '#6d28d9' }}>{ap}</b></span>;
}

// Linia "Zamowienie ..." w Zwrotach.
export function OrderNoLine({ apilo, ok }: { apilo?: string | null; ok?: string | null }) {
  const src = useOrderNumberSource();
  const useOk = src === 'ok';
  const val = useOk ? ok : apilo;
  if (!val) return null;
  return (
    <div style={{ fontSize: 12, color: '#111827', marginBottom: 8 }}>
      {useOk ? 'Zamówienie OK: ' : 'Zamówienie Apilo: '}
      <b style={{ fontFamily: 'monospace', cursor: 'pointer' }} title="Kliknij, aby skopiować" onClick={() => copy(String(val))}>{val}</b>
    </div>
  );
}
